import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getOperationsSelector } from '../selectors'
import { OperationsConstants } from '../store/operations.constants'
import { IOperationsState } from '../store/operations.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const operationsState: IOperationsState = yield select(getOperationsSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = operationsState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === OperationsConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([OperationsConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
